import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'Become an Affiliate | Ship&Play',
  description:
    'Our affiliate partners spread the word, earn rewards, and help their followers discover ' +
    "the smarter way to travel. It's a win-win, for you and your audience.",
  alternates: {
    canonical: 'https://www.shipplay.com/affiliate',
  },
}

export default metadata
